<template>
  <section class="character" v-bind:class="{'is-show':showChara}">
    <div class="character_in">
      <h2 class="character_ttl">
        <span class="character_ttlTxt">Character</span>
      </h2>

      <ol class="character_list">
        <li class="character_listItem" v-for='(chara, index) in items' :key='index'
          
          v-bind:class="[{'is-selected':showChara&&crrChara==index},'character_listItem-'+(index+1)]"
          v-bind:id="['chara'+(index+1)]">
          <div class="character_listItemIn" @click="showChara=true,crrChara=index,scrollToTarget('chara'+(index+1))">
          <p class="character_listCont">
            <span class="character_listNum">
              <span class="character_listNumTxt">0{{index+1}}</span>
            </span>
            <span class="character_listName">
              <span class="character_listNameTxt">{{chara.name}}</span>
            </span>
          </p>
          </div>
          <div class="character_detail-sp">
            <div class="character_detailIn">
              <div class="character_detailIn2">
                <h3 class="character_name">
                  <span class="character_num">
                    <span class="character_numTxt">{{chara.num}}</span>
                  </span>
                  <span class="character_name">
                    <span class="character_nameTxt">{{chara.name}}</span>
                    <span class="character_nameJp">{{chara.nameJp}}</span>
                  </span>
                  <span class="character_latin">MAZEDOLL::{{chara.latin}}</span>
                </h3>

                <div class="character_reportTxt">

                  <p class="character_reportTxtIn" v-for='p in chara.description' v-bind:key='p.id'>
                    {{p.txt}}
                  </p>
                </div>



                <h4 class="character_detailTtl">
                  <span class="character_ttlTxt">Governing Country</span>
                </h4>
                <div class="character_governing">
                  <div class="character_governingIn">
                    <p class="character_countrySymbol">
                      <img v-bind:src="embPath[index]" alt class="character_countrySymbolImg">
                    </p>
                    <p class="character_countryInfo">
                      {{chara.countryName}}
                      <span class="character_countryCode">Country code: {{chara.countryCode}}</span>
                    </p>
                  </div>
                  <div class="character_countryDesc">
                    <p class="character_countryDescTxt" v-for='p in chara.countryDescription' v-bind:key='p.id'>
                      {{p.txt}}
                    </p>
                  </div>
                </div>
                <div class="character_pco">
                  <h4 class="character_detailTtl">
                    <span class="character_ttlTxt">PCO Report - {{chara.pcoTtl}}</span>
                    <span class="character_reportId">ID:{{chara.reportId}}</span>
                  </h4>
                  <p class="character_pcoDescTxt" v-for='p in chara.pcoDesc' v-bind:key='p.id'>
                    {{p.txt}}
                  </p>
                </div>
                <div class="character_footer">
                  <div class="character_footer1">
                    <p class="character_footerSymbol"></p>
                    <p class="character_footerName">
                      <span class="character_footerNameTxt">{{chara.name}}</span>

                      <span class="character_footerCode">{{chara.nameCode}}</span>
                    </p>
                  </div>
                  <div class="character_footer2">
                    <img :src="codePath[index]" alt class="character_footerBarcode">
                  </div>
                  <div class="character_footer3">
                    <span class="character_footerMdNum">MD::{{chara.num}}</span>
                    <span class="character_footerMdCode">{{chara.mdCode}}</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </li>
      </ol>
    </div>

    <transition-group name="chara" tag="div" class="character_detail character_detail-pc">

      <div class="character_detailIn" v-for='(chara, index) in items' :key='chara.num' v-show="crrChara==index"
        v-bind:class="['character_detailIn-'+(index+1)]">
        <div class="character_detailIn2">
          <div class="character_detailIn3">
            <h3 class="character_name">
              <span class="character_num">
                <span class="character_numTxt">{{chara.num}}</span>
              </span>
              <span class="character_name">
                <span class="character_nameTxt">{{chara.name}}</span>
                <span class="character_nameJp">{{chara.nameJp}}</span>
              </span>
              <span class="character_latin">MAZEDOLL::{{chara.latin}}</span>
            </h3>

            <div class="character_reportTxt">

              <p class="character_reportTxtIn" v-for='p in chara.description' v-bind:key='p.id'>
                {{p.txt}}
              </p>
            </div>

            <h4 class="character_detailTtl">
              <span class="character_ttlTxt">Governing Country</span>
            </h4>
            <div class="character_governing">
              <div class="character_governingIn">
                <p class="character_countrySymbol">
                  <img v-bind:src="embPath[index]" alt class="character_countrySymbolImg">
                </p>
                <p class="character_countryInfo">
                  {{chara.countryName}}
                  <span class="character_countryCode">Country code: {{chara.countryCode}}</span>
                </p>
              </div>
              <div class="character_countryDesc">
                <p class="character_countryDescTxt" v-for='p in chara.countryDescription' v-bind:key='p.id'>
                  {{p.txt}}
                </p>
              </div>
            </div>
            <div class="character_pco" :class="{'is-active':chara.isActive}">
              <h4 class="character_detailTtl2" @click='chara.isActive=!chara.isActive'>
                <span class="character_ttlTxt">PCO Report - {{chara.pcoTtl}}</span>
                <span class="character_reportId">ID:{{chara.reportId}}</span>
              </h4>
              <p class="character_pcoDescTxt2" v-for='p in chara.pcoDesc' v-bind:key='p.id'>
                {{p.txt}}
              </p>
            </div>
            <div class="character_footer">
              <div class="character_footer1">
                <p class="character_footerSymbol"></p>
                <p class="character_footerName">
                  <span class="character_footerNameTxt">{{chara.name}}</span>

                  <span class="character_footerCode">{{chara.nameCode}}</span>
                </p>
              </div>
              <div class="character_footer2">
                <img :src="codePath[index]" alt class="character_footerBarcode">
              </div>
              <div class="character_footer3">
                <span class="character_footerMdNum">MD::{{chara.num}}</span>
                <span class="character_footerMdCode">{{chara.mdCode}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition-group>

    <div class="dummy" style="width:1px;height:1px;overflow:hidden;position:absolute">
      <img src="@/assets/chara_1.png" alt="">
      <img src="@/assets/chara_2.png" alt="">
      <img src="@/assets/chara_3.png" alt="">
      <img src="@/assets/chara_4.png" alt="">
      <img src="@/assets/chara_5.png" alt="">
      <img src="@/assets/chara_6.png" alt="">
      <img src="@/assets/chara_7.png" alt="">
      <img src="@/assets/chara_line_1.png" alt="">
      <img src="@/assets/chara_line_2.png" alt="">
      <img src="@/assets/chara_line_3.png" alt="">
      <img src="@/assets/chara_line_4.png" alt="">
      <img src="@/assets/chara_line_5.png" alt="">
      <img src="@/assets/chara_line_6.png" alt="">
      <img src="@/assets/chara_line_7.png" alt="">
      <img src="@/assets/chara_line_1.png" alt="">
      <img src="@/assets/chara_line_2.png" alt="">
      <img src="@/assets/chara_line_3.png" alt="">
      <img src="@/assets/chara_line_4.png" alt="">
      <img src="@/assets/chara_line_5.png" alt="">
      <img src="@/assets/chara_line_6.png" alt="">
      <img src="@/assets/chara_line_7.png" alt="">
      <img src="@/assets/chara_line_1_white.png" alt="">
      <img src="@/assets/chara_line_2_white.png" alt="">
      <img src="@/assets/chara_line_3_white.png" alt="">
      <img src="@/assets/chara_line_4_white.png" alt="">
      <img src="@/assets/chara_line_5_white.png" alt="">
      <img src="@/assets/chara_line_6_white.png" alt="">
      <img src="@/assets/chara_line_7_white.png" alt="">
    </div>
  

  </section>
</template>
<script>
export default {
  name: "app",
  data: function () {
    return {
      showChara: false,
      crrChara: -1,
      codePath: [
        require("@/assets/code_586F726E656C697573.svg"),
        require("@/assets/code_436C617564697573.svg"),
        require("@/assets/code_4A756C697573.svg"),
        require("@/assets/code_56616C6572697573.svg"),
        require("@/assets/code_53656D70726F6E697573.svg"),
        require("@/assets/code_41656D696C697573.svg"),
        require("@/assets/code_446F6D6974697573.svg"),
      ],
      embPath: [
        require("@/assets/emblem_1.svg"),
        require("@/assets/emblem_2.svg"),
        require("@/assets/emblem_3.svg"),
        require("@/assets/emblem_4.svg"),
        require("@/assets/emblem_5.svg"),
        require("@/assets/emblem_6.svg"),
        require("@/assets/emblem_7.svg"),


      ],
      items: [{
          num: '01',
          name: 'Xornelius',
          nameCode: '586F726E656C697573',
          nameJp: 'コーネリアス',
          latin: 'UNUS',
          countryName: 'ALVHADIPTOS',
          countryCode: 'ALV',
          reportId: 'ALV-586F-4a95',
          isActive:false,
          description: [{
              id: 'a01',
              txt: '一番最初に開発されたとされる人工神。忠誠を重んじる性格をしており、言葉遣いも基本的に丁寧語である。物理的接触を極端に避けるが、会話は好む。'
            },
            {
              id: 'a02',
              txt: '自身は王でありながら、アルバティトスの騎士達にとっての騎士団長であり、一般の騎士にも国民にも分け隔てなく接する。非常に堅実な性格をしており、常にいかなる相手にも敬意を払い、よほど失礼な態度をとられない限り怒る事は殆ど無い。騎士達への鍛錬は厳しく過酷なものが多いが、その性格さ故信頼は絶大である。'
            }, {
              id: 'a03',
              txt: 'この機体だけ、他の機体にはないブラックボックスプログラムがある。'
            }
          ],
          countryDescription: [{
              id: 'a04',
              txt: '騎士団を主とした国家である。コーネリアスの指揮の元、各国での人的な争い事や政治的/自然的な問題解決等に対応している。'
            },
            {
              id: 'a05',
              txt: '国の北方海面に面する地域には、国土に被さるような形で王宮があり、「騎士団」を形成している。国民の男性の就職は殆どがこの騎士団であり、非常に誇り高いコーネリアスの性格と統治もあって国民全体には強い正義感と自己犠牲の精神を教育される。'
            },
            {
              id: 'a06',
              txt: '生活に必要な資源の調達は他国からの輸入が殆どであるが、騎士団の出張が多い為、これを交渉材料としている。父親が騎士で単身赴任、母は女手一つで子を育てる、という家庭が多い。'
            },

          ],
          pcoTtl: 'KHALMIER',
          pcoDesc: [{
              id: 'a07',
              txt: 'コーネリアスは国を統治する存在にして、自身に仕える騎士団の隊長であった。騎士団という名称ではあるが、アルバティトスの人口凡そ40%がこれを占めるため、企業の体制に近い。「護る事が使命である」としているが、国間での戦争は起きていない為、過去の教訓に従い「仮に相手が人間だったとしても、人ではなく脅威の原因を駆逐する」として人々は騎士となり日々鍛錬をしている。'
            },
            {
              id: 'a08',
              txt: 'そんな中、隊の中のとある男が、別の小隊の人間を殺してしまった。原因はささいな争いからであった。これを知ったコーネリアスは激怒。一個隊のメンバーとしてではなく、人として犯した最大の過ちとして加害者であった男に「彼の者の痛みは天秤に掛けられない程に重い。貴様には同じ傷みを与える」と言った。周囲に一瞬、青白い閃光が走り、その男は誰に従うでもなく、自らの足で罪人を収容する独房へ向かい出した。男は「違う」「私は望んでいない」などと叫びながら、自ら独房へ入る。以後男の処遇を知る者は少ないが、看守によると「自らが死するまで」只管に殺した男の致命傷となった頭の同箇所を地面に打ち付け続け、一定の出血に達しては停止し、再びそれを再開する、という事を3日間繰り返し続けた末、死亡した。看守たちは一度だけ、その男が独房に入る瞬間に同行したコーネリアスが放つ光を目撃しており、それ以降「独房の前を通り過ぎる時だけ、体が必ず独房を見ずに通り過ぎてしまい、男が何をやっているか確認できない」という奇妙な現象が起こった。「叫び声と鈍い音だけは聞いていたが、見ようとしても独房の中が見れなかった」と語っている。王であるコーネリアスの勅令での監禁ということもあり、だれもこの話題に触れることはなかったが、監禁中にこの男について話そうとしても、なぜか「口があかない」という現象も起こっていたそうだ。'
            },
            {
              id: 'a09',
              txt: 'この事件の後は、男が収容されていた独房は見れるようになったという。'
            }

          ],
          mdCode: '4D617A65646F6C6C3031',
        },
        {
          num: '02',
          name: 'Claudius',
          nameCode: '436C617564697573',
          nameJp: 'クラウディアス',
          latin: 'DUO',
          countryName: 'VETUELL',
          countryCode: 'VTL',
          reportId: 'VTL-436C-7a26',
          isActive:false,
          description: [{
              id: 'b01',
              txt: '人工神の中で最も発声しない。が、感情表現は豊か。自身の提示する知識に対する人の動向を記録として残すのが趣味らしい。接触全般を極端に避け、不用意なコミュニケーションも嫌う。人を小馬鹿にするような発言もしばしば、王宮の側近を困らせることが多い。基本的にはヴェチェルの大図書館に引きこもっており、国民の前に姿を現すのは稀である。'
            },
            {
              id: 'b02',
              txt: 'たとえ王宮内の人間であったとしても、少しでも自分の許容する範囲外の行動をとられると酷い暴言で罵倒することもしばしば。'
            }
          ],
          countryDescription: [{
              id: 'b04',
              txt: '国民は歴史を尊いものとして貴び、価値のある物の保存や景観の保持をしている。各家庭には国から支給された分本/写本が配布されており、さらに日記を付け保管し続けることが法律として定められている。子供達の通う学校では、歴史の授業の割合が非常に多く、多科目もこの歴史の授業から知識を得られることが殆どなほど。'
            },
            {
              id: 'b05',
              txt: '街の景観も古い建物などが多く、歴史的価値のある建造物が随所に存在する。これまでの世界の歴史を記した書物や現存するありとあらゆる記録媒体が国の中心に鎮座する超巨大図書館「ヴェチェル中央宮大図書館」へ集められている。'
            },
          ],
          pcoTtl: 'PHADOBEL',
          pcoDesc: [{
              id: 'b06',
              txt: 'クラウディアスは、国の中央にある巨大な書庫に居る。これはクラウディアスが国の民に作らせたもので、全世界に存在する書物という書物の写本がそろっている場所である。彼女はここで基本的に過ごしており、国の統治に関する政治の際には、文章だけをここから発信し自らが動き出すことはまず無い。さらに、ここに写本の格納以外の用事で侵入してくる者に対しては、攻撃こそしないものの酷い罵倒で追い返す事を繰り返している。但し、まれに入室者に対して「問題を解いてみなさい」と言い、自身が問うた問題に対して入室者が正解に近しい答えを出さない限り、一晩中でも部屋から出さない、など謎の行動をしていた。この時だけ、クラウディアスはとても楽しそうに人を小ばかにするような素振りを見せる。'
            },
            {
              id: 'b07',
              txt: 'ある時、新たな写本を格納するために3人の入室者があった。3人は了承を求めると、無言のままペンを机に打ち付ける音を聞いた。これがクラウディアスの入出許可の意である。3人は棚へ本を格納している最中、別の本棚に人体が描かれた本を見つける。何かの写真のようにも見えるが、この書物を格納した記憶がない。見れば、写本ではなくオリジナルの書物の様であった。表紙には人体が描かれており、物音を立てないようにこっそりとその中身を3人で囲って確認した。そこまで厚くない、むしろ薄いその本には等身が低い人体と、何か星座の配置のような穴がそれぞれのページにあけられており、返しの裏ページには何も書かれていない、というのが15ページ分あった。だが、最後のページのみ、人の体から羽化する人のような奇怪な絵が描かれていた。ここで、3人のうちの一人が驚き、声を上げてしまう。3人が顔を上げると、　いつも以上に無表情、無機質的なクラウディアスが居た。「見たのね」「失礼な子」「手間が掛かる事は嫌いなのよ」この3言葉を発した。'
            },
            {
              id: 'b08',
              txt: 'それから、彼らは気が付いたら書庫の整理を終えていた。書庫の外にいた別の館の人間が中で音がしていたのを聞いたらしく、「何があった？」と聞いた。3人は「いつも通り格納は終わったよ。これから3人でご飯に行くけど、みんなはどうする？」と言った。'
            }

          ],
          mdCode: '4D617A65646F6C6C3032',
        },
        {
          num: '03',
          name: 'Julius',
          nameCode: '4A756C697573',
          nameJp: 'ユリウス',
          latin: 'TRES',
          countryName: 'DOR SANQLUS',
          countryCode: 'DSQ',
          reportId: 'DSQ-4A75-4a8d',
          isActive:false,
          description: [{
              id: 'c01',
              txt: '人工神の中では最も精神年齢が高いような仕草をする。人との接触、交流を好み、国民からは「母様」と呼ばれている等、隣人や家族のような扱いをしたりする事が程んどである。その寛大な精神と圧倒的な国民の支持のため、他国からユリウス王に会いに来る人間も多い。'
            },
            {
              id: 'c02',
              txt: 'ドル サンクラスの農業を主軸とする生活は彼女無しでは成り立たない程に、国内の農政策の指揮をほどんど一人でこなしている。若干悪戯っぽい部分もある為、思いつきで王宮の関係者を振り回すこともある。'
            }
          ],
          countryDescription: [{
              id: 'c04',
              txt: 'ラオ ラリアルを除く他国のほとんどの食糧供給を行っているのがドル サンクラスである。'
            },
            {
              id: 'c05',
              txt: 'ユリウスの指揮下のもと、ほとんどの家庭では庭と畑を持ち、国内の職業は全て農業に関連するものである。そのため、他国の出入りがとても多く、ユリウスの性格もあってか人々は他国の人間を歓迎するような姿勢を常に大事にしている。ユリウスは常日頃から王宮を離れ街や村に出向いている為、国民の殆どが王と会話している。'
            },
            {
              id: 'c06',
              txt: '毎年全ての国で行われる「機神祭」はこの国が一番規模が大きく、盛大であるため機神祭の日は観光による人の出入りがとても多い。このお国柄もあってか、犯罪発生率は極端に低い。'
            }
          ],
          pcoTtl: 'EARISM',
          pcoDesc: [{
              id: 'c06',
              txt: 'ユリウスの統治国家では、農業が非常に盛んであり、他国への食糧供給もほぼこの国が行っているような規模である。これらはユリウスの直接の指揮のもと行われており、盛んに国民と交流している。ユリウスは国民から絶大な信頼を寄せられていると同時に、非常に温厚な性格も相まって、一国民、隣人のような関係すらあった。国民からは「母様」と呼ばれている程に、人の家族や友人という関係に興味を示し、自ら関わっていた。中には、幼少期から育ての親のうちの一人と言われるほどに密接に関わりを持っている者すらいた。'
            },
            {
              id: 'c07',
              txt: 'ある時、古い農村の家に一人で住む老婆が倒れた知らせがユリウスのもとに入る。その老婆は地方の農村の旧管理者であり、現在は娘とその婿に後を継がせているものの、かつてはユリウスの指導のもと、国の繁栄を大きく手助けした土地の保有者その人であった。ユリウスは老婆に会い、別れが近い事を自ら語る老婆の話を聞き続けた。この老婆は幼少期からユリウスと関わり、まさにユリウスはもう一人の母と呼べるような存在のそれであった。「あの頃の私にまた戻る事が出来れば、また貴方の力になれるのに」と、老婆はか細い声で言った。瞬間、ユリウスから翡翠色の色の光が放たれ、老婆の横たわる部屋を照らした。「何を言っているのかしら。あなた、とても奇麗よ。」とユリウスが言う。'
            },
            {
              id: 'c08',
              txt: 'ここから3日程、ユリウスはこの部屋で過ごす。この時、ユリウスは他の者の部屋への侵入を禁止していた。この三日間の間で老婆の友人が一人、彼女に会いに来たが、家の回りには国の護衛官がおり、家への侵入は許可されなかった。友人は様子が変だと思い、外から老婆の居る部屋を覗き込んだ。窓にはすべて映り切らなかったが、そこには楽しそうに話すユリウスの姿と、ベッドからそれに相槌の様に手を伸ばす若い女性の手が見えた。友人は、この女性の手と声に不思議ななつかしさを感じた。'
            },
            {
              id: 'c09',
              txt: 'それから3日後、老婆は死んだ。埋葬はユリウスの手で直接行われた。棺は、老婆のものより少し背が高い棺だった。'
            }

          ],
          mdCode: '4D617A65646F6C6C3033',
        },
        {
          num: '04',
          name: 'Valerius',
          nameCode: '56616C6572697573',
          nameJp: 'ヴァレリウス',
          latin: 'QUATTUOR',
          countryName: 'GUMMRAD',
          countryCode: 'GMR',
          reportId: 'GMR-5661-9d02',
          isActive:false,
          description: [{
              id: 'd01',
              txt: '人との接触を好み、国民からは絶大な忠誠と信頼を得ている。王であると同時に、国全体が軍という組織であるガムラドの最高指揮官である。コーネリアスとは仲が良いようで、互いの精神性の近さを自覚しているようである。'
            },
            {
              id: 'd02',
              txt: '国内外問わず、人類の障害たりうる自然的脅威の排除/殲滅に余念がなく、かつ王宮内の人間にも誠意のある対応をする、とても仕事熱心な性格。本人の素としてはフランクな性格だがその姿勢であるがゆえに、かなり際どい冗談を発言して王宮内の人間を凍り付かせることが多い。'
            }
          ],
          countryDescription: [{
              id: 'd03',
              txt: 'ガムラドは全国の中でも特殊な国の構造をしており、一国が一つの軍として包括されている。とは言え通常の生活は営まれており、民家も存在するが家屋の細部には自然的脅威に対抗しうる手段の設置が義務付けられている。'
            },
            {
              id: 'd04',
              txt: '人民のそれぞれがヴァレリウスの指示のもと与えられた防衛の手段を有しており、（実用の機会こそ少ないものの）他国への支援を行う事が出来る。そのため、共働きの家庭が比較的多く、子供は共同の教育施設で幼少期を過ごす家庭が多い。'
            },
            {
              id: 'd05',
              txt: '定期的にヴァレリウスによる「公開演習」なる軍事施設の開示が行われており、自然的脅威に対する各個人の防衛意識を高める画策をしている。'
            },
          ],
          pcoTtl: 'GOAVEL',
          pcoDesc: [{
              id: 'd06',
              txt: 'ヴァレリウスの統治国家はひとつの軍であり、国自体がそもそも大きな一軍隊、ということである。これはコーネリアスのような志願による軍隊でなく、半強制的に成人以上は軍に関わることになっている。ただし、やはり人間同士の争いは起きていないため、こちらの目的は「外敵脅威からの護衛」と共に、「人が持ちうる限りの軍的な設備の配備と、自然的驚異の駆逐」が目的である。そのため、原因が明確でない超自然的災害にも軍隊の対応として出動することがある。'
            },
            {
              id: 'd07',
              txt: 'ヴァレリウスは軍の総指揮官としての役割を担っている。その中で、ありとあらゆる陣形の指揮、作成を行う。人民からの信頼は厚く、特に子供たちへの政治的な支援は手厚い。ある時、ヴァレリウスは「子供たちの未来のため、子のある家庭は訓練現場に子供を連れてくるように」と指令を出した。これはヴァレリウスの考える「未来を担う子供たちに、戦うとは何かを考えさせる」という画策からだった。訓練は廃墟を利用した模擬戦であり、子供たちは安全な区画からこれを見学、演習の概要を学ぶというものであった。しかし訓練中、一人の女性が「わが子の姿が見当たらない」と言った。近くにいた兵は、「私たちに任せて下さい」と捜索を引き受けたが、子供の姿が見当たらない。全体の演習の規模は大きく、また国民も多く観覧しているために中断が難しい。訓練は続く中で、ヴァレリウスがこの知らせを受ける。ヴァレリウスは指揮取りつつも安全地域の拡大をはかりつつ、実戦闘区画を狭めていった。演習終盤に差し掛かった時、戦闘区画から外れた場所に、子供の姿を見つける。子供は母を呼び泣いており、廃墟の一角から出ようとしているところだった。その時、廃墟の瓦礫が崩落を起こした。今まさに子供のいる直下に瓦礫が落ちようとしたその時に、ヴァレリウスを中心として赤い閃光が走った。瓦礫は崩れ落ち、子供は生き埋めになってしまった。母親は悲鳴を上げた。だが、そこにヴァレリウスが母の肩を支えた。「あの子なら大丈夫だ」そう言った。'
            },
            {
              id: 'd08',
              txt: 'ヴァレリウスが現場に向かっていき、子供の上に被さった瓦礫を除けると、そこには頭を守るような体制で腕を組んで泣く子供の姿が。「強い子だ。大切に育てなさい。」そう母親に伝えると母親は泣き崩れ感謝し、周囲からは歓声が起こった。無事演習は終了し、会場の撤収作業に入ったとき、ある兵たちは言った。「それにしてもすごい偶然だ。まさか運よく瓦礫を避けるとはなあ」「しかしあの瓦礫の量だぞ。何かおかしくないか？」気になった兵は子供を埋めていた瓦礫の山を見た。ちょうど子供に被さっていた鉄筋は、子供がいた場所を中心にまるで針金のようにぐにゃりと曲がっていた。中心の凹みは、不自然なまでに子供の腕の形をしていた。'
            }

          ],
          mdCode: '4D617A65646F6C6C3034',
        },
        {
          num: '05',
          name: 'Sempronius',
          nameCode: '53656D70726F6E697573',
          nameJp: 'センプロニアス',
          latin: 'QUINQUE',
          countryName: 'MARHATIA',
          countryCode: 'MRH',
          reportId: 'MRH-5365-2c87',
          isActive:false,
          description: [{
              id: 'e01',
              txt: '全人工神の中で、最も人間と接触の多い人工神である。'
            },
            {
              id: 'e02',
              txt: 'センプロニアスは王であると同時にマルハティアの研究所所長と言う肩書も持っており常に研究棟の人間との交流を行っている。そのため、王と言うよりかは国民からは会社の代表のような、上司や同僚のような扱いを受けている事がほとんどである。'
            }, {
              id: 'e03',
              txt: '知識レベルとしては人間との差は大きくない人工神達の中で最も人間と化学の結びつきを探求しており、人間がどれだけ化学技術により生活を豊かに出来るかの研究を怠らない。本質的な性格としては非常に悪戯っぽく、さらに鈍感な為、デリカシーの無い発言をする事も稀にある。'
            }
          ],
          countryDescription: [{
              id: 'e04',
              txt: 'マルハティアは化学の研究所が点在しており、さらに国の中央には巨大な研究棟が鎮座している。全国の中でトップの化学技術力を有しており、その開発を日々行っている。'
            },
            {
              id: 'e05',
              txt: 'すでに全国に普及している「思考装置」もこのマルハティアで開発されたものであり、全てセンプロニアスの画策のもと技術開発を行っている。常に最先端の技術を導入する姿勢から、若者の流行はこの国から発信されることも多い。'
            },
            {
              id: 'e06',
              txt: 'また、あらゆる病気に対する研究をしている医療施設も併設されており、他国で難病にかかってしまった場合例外なくマルハティアで治療を受ける。その医学の発展から、国民の平均寿命は全国一位である。'
            },
          ],
          pcoTtl: 'STELCYEQ',
          pcoDesc: [{
              id: 'e07',
              txt: 'センプロニアスの統治する国家は、所謂「化学」を追求する事を国の使命としている。これは、センプロニアスによる「人間の可能性は化学により進展して来た」という理念のもと、テクノロジーで人類をより豊かに、高度な文明にするためである。国のいたる所に化学研究施設があり、自宅が研究室、という家庭もとても多い。その中で、国の中心に位置する場所にある超巨大な研究塔にセンプロニアスは「塔の長」という形で、そこにいる科学者たちと研究を重ねている。'
            },
            {
              id: 'e08',
              txt: 'センプロニアスは非常に温厚かつ実直、また、差別や階級を感じさせる素振りを一切しないため、立場こそあれど周囲の国民からは「同僚」のような扱いを受けている。当然、国の王であり神とする存在のため、最低限の忠義と振る舞いこそあれど、本人がそれを全く気にせずに接しているため、職員たちの友人のようであった。ある時、国の中で重度の伝染病が大流行した。これは他国にも及び、早急な対処が必要とされた。外交のある国の外れにある研究所のチームは連日連夜対応のためのワクチン生成の方法を探していたが、対応しうる薬こそあれど、重度の副作用を引き起こすもので完全ではなかったため、打開策が求められていた。これを聞きつけたセンプロニアスが、研究員の一人に言った。「今から直ぐに、この素材を取ってくるように。」センプロニアスが渡したメモには、北の山に生息する菌類、研究所の近くにある湖に生息する小魚、どこにでも生えている種の雑草など、集めるのにあまり時間のかからないものが書かれていた。これで抗体を作るのか・・・？と疑問を感じていた科学者たちだったが、彼女の言う事とあれば信じるほか無く、一晩でこれを集めた。翌日、職員のうち「双子の弟」の立場にある職員を呼び出した。彼は研究者でなく事務側の人間であったが、王から直接の呼び出しがかかるなど思ってもいなかったため、大変に恐縮していた。看護服を着せられた男の前にセンプロニアスが立つ。「今から、昨晩作ったこの薬を飲みなさい。」男は件の伝染病ではなく、どういうことなのか全く理解出来なかった。しかし、センプロニアスは「君が最後のカギなんだ。」と言う。男が薬を飲み干した瞬間、センプロニアスから藍色の閃光が放たれた。'
            },
            {
              id: 'e09',
              txt: '男が次に気が付いたとき、病棟の寝台にいた。何が起こったか分からず周りを見渡してみると隣にはセンプロニアスがおり、男は問いかけた。「私はどうなったのですか？先ほどの薬は一体何だったのですか？」センプロニアスはこう続けた。「おめでとう。君は最高の遺伝子だ。君のおかげで国は救われた。」男にはその意味が理解できなかったが、センプロニアスの手には、赤い血の入った試験管が握られていた。'
            },
            {
              id: 'e10',
              txt: '翌日、国全体に向けて「伝染病のワクチンが開発された」と発表があった。薬は瞬く間に普及し、病原菌は根絶された。この年から、何故か特定の血液型の組み合わせの夫婦から生まれる子供には、双子が生まれる確率が高くなった。'
            }

          ],
          mdCode: '4D617A65646F6C6C3035',
        },
        {
          num: '06',
          name: 'Aemilius',
          nameCode: '41656D696C697573',
          nameJp: 'アエミリウス',
          latin: 'SEXA',
          countryName: 'LAW RARYAL',
          countryCode: 'LWR',
          reportId: 'LWR-4165-03d4',
          isActive:false,
          description: [{
              id: 'f01',
              txt: '人間との接触を自ら積極的に行い、王宮内の役職として「家族」という正式な立場を用意させている非常に特異な人工神。'
            },
            {
              id: 'f02',
              txt: '「愛情」に対して深い関心を置き、他人と関りを持つ事こそが人間の義務であるという信条のもと国民同士がより深く接する機会を多く設け、国内では何かと宴会や集会が多く行われている。ラオラリアルでの結婚式では、アエミリウスから祝いの言葉を頂戴する、という文化が出来ておりアエミリウス自身もほぼ国民ほぼ全員の名前を把握している。但し、かなりそそっかしい性格な為、自分の行動に側近を無理やり引き連れて振り回すことが多い。'
            }
          ],
          countryDescription: [{
              id: 'f04',
              txt: 'ラオ ラリアルは全国の中で最も広大な土地を有しており、人口も全国でトップの国である。'
            },
            {
              id: 'f05',
              txt: '他国からの支援は(アルバティトスの騎士派遣やドル サンクラスの特産物などを除いて)ほぼ受け取っておらず、それぞれの家庭が独立して暮らせるような画策が為されている。'
            },
            {
              id: 'f06',
              txt: 'さらに、総合的な施設も多く内包しているため、ラオ ラリアルの住民達から他国に住居を移す者はほぼいない。但し、人口も国土面積も多い分、富豪層/貧困層との差も大きく、問題となっている。アエミリウスもそういった現状も自覚してはいるが争いを起こさないままどうやって政治を行うか、日々頭を抱えているようだ。'
            },
          ],
          pcoTtl: 'RIVIDAL',
          pcoDesc: [{
              id: 'f07',
              txt: 'アエミリウスの統治するラオ ラリアルでは、一国内で完結する生活形態が完成されている。そのため、特に外部からの供給を必要とすることなく、GDPが非常に高い。さらに人民の数も他国と比べ最も多く、国内での犯罪率も低い。アエミリウスは非常に開放的かつ奔放な性格であり、国民への愛情を深く注いでいる。挙式をあげる際には他国からはるばるラオ ラリアルまで出向いて式を行う人間も多い。'
            },
            {
              id: 'f08',
              txt: 'その中で、アエミリウスは人口の統計、傾向のデータ、さらには人間一人当たりの生産率などを常に処理/展開している統計学士のような存在である。これを他国に展開することにより、各国の王へ人間たちの指示の指標として情報共有している。'
            },
            {
              id: 'f09',
              txt: 'ある日、国内で初めて殺人の事件が起きた。これにアエミリウスは激怒し、グラヴェオへ送検される前にその犯人である男を王宮へ連れ出し、直接尋問を行った。男が殺人を犯した理由は、女との関係の解れ、および強姦をしたという事であり、弁明のしようのない完全に破綻した理由であった。この話を直接王の間で聞いていた側近たちは凍り付き、王がこのままこの男を殺してしまうのではないかと危惧したが、その直後にアエミリウスから桜色の閃光が一瞬煌き、男はしばらく立ち尽くした後に突然自らの罪状を洗いざらい吐き続け、縄の拘束を引きちぎり叫び、発狂した。王の間の人間たちも何が起こったのか一切理解できていなかったが、アエミリウスはただ黙ってその鎖のような装身具をうならせているのみであった。突然発狂した男は神への冒涜の言葉をしばらく吐き続けのたうち回った挙句、舌を切って自害した。アエミリウスは「あら、死んでしまってはグラヴェオにどう報告すればいいのかしらね。ドミティウスには私から連絡する。」と言った。居合わせていた王室の人間たちは、なぜか恐怖するどころか心の底から安堵していたという。'
            },
            {
              id: 'f10',
              txt: 'この一連の事件は門外不出の記録として王の間に居合わせた人間のみにとどめられた。この出来事は、「グラヴェオにて裁かれた」という決着の元処理され、何が起こったのかを知る者はいない。'
            }

          ],
          mdCode: '4D617A65646F6C6C3036',
        },
        {
          num: '07',
          name: 'Domitius',
          nameCode: '446F6D6974697573',
          nameJp: 'ドミティウス',
          latin: 'SEPTA',
          countryName: 'GRAVEO',
          countryCode: 'GRV',
          reportId: 'GRV-446F-07ff',
          isActive:false,
          description: [{
              id: 'g01',
              txt: '全人工神のご意見番のような存在で、非常に厳正な態度を決して崩さず、かつ国内だけでなく全国で裁判が行われる犯罪に対する最終決定権を握っている人工神。グラヴェオの「大法廷」の管理者であり、裁判長でもある。'
            },
            {
              id: 'g02',
              txt: '基本的に温厚ではあるが、気難しい性格でもある為王宮の人間からも尊敬の他、ある種の畏怖の対象とされいるほど。平等を非常に重んじており、自身が尊厳のある王であり続ける事を常に考えているため、国民の前に姿を現すのも機神祭の時以外は皆無である。'
            }, {
              id: 'g03',
              txt: 'あまり冗談を好まず、気軽に話そうとする者はまずいない。理由は不明だが年に数回、国の統治を王宮の人間に全て任せる期間がある。'
            }
          ],
          countryDescription: [{
              id: 'g04',
              txt: 'グラヴェオは、全世界中で最も人口が少ない国家である。その規模はラオ ラリアルの半分ほどであり、自己生産率も他国と比べると低い。これは、グラヴェオの教育体制から来るもので、幼少期から非常にレベルの高い勉学を義務付けており、成人後に他国へ優秀な人材として派遣される確率が多いからである。'
            },
            {
              id: 'g05',
              txt: '科学研究に余念の無いマルハティアの科学者の上層部も、グラヴェオ出身者がかなり多い。国全体の雰囲気は非常に閑静かつ穏やかな国である。若者は国を離れ、定年を迎える前にグラヴェオに帰り晩年を過ごす、という一種のサイクルのようなものがあり、高齢者の割合が高い。'
            },
            {
              id: 'g06',
              txt: '国の中央には一つの町のような規模を誇る「グラヴェオ司典記念館」がある。'
            },
          ],
          pcoTtl: 'MEZAIE',
          pcoDesc: [{
              id: 'g06',
              txt: 'ドミティウスが統率するグラヴェオの中央には、国のシンボルになっている巨大な法廷施設が存在する。この施設にはグラヴェオだけでなく他国からの罪状を持つ多くの者が運ばれる為、この施設の北側、つまり正門から逆位置に存在する小道は「懺悔の廊下」と呼ばれている。ドミティウス自身、全世界の法廷を指揮する裁判長と言うその激務から国民の前にも王宮の外すらもあまり姿を現すことは無く、王の存在は認知こそされているものの、ドル サンクラスやラオ ラリアルのような身近な存在では決してない。'
            },
            {
              id: 'g07',
              txt: 'ある時、ドミティウス王が自ら複雑な犯罪ケースを想定し、模擬的な裁判を行い対処の方法を考える、という所謂実践会議のような形式がとられた裁判演習があった。この時、開場から既に違和感があった。予行の裁判としては異例の裁判官の数と観覧の人数で、確かに国からの招集こそあったもののここまで人の多い予行を行うという事はこれまでに無く、異様な雰囲気を放っていた。だが、予定通りの進行で裁判演習は行われ、程なくして終了した。この時には特に会場の人間も気が付いていなかったが、ドミティウスが席を立った瞬間に金色の閃光が一瞬放たれたのを見たものがいた。'
            },
            {
              id: 'g08',
              txt: 'この2日後、ドミティウス王は年に数回ある「立て込み事案」により王室を出なかった。'
            },
            {
              id: 'g09',
              txt: '同日、アルバティトスから派遣されたとある騎士が、街の外れにある小さな宿で宿の管理人にとある質問をしていた。　その騎士は「今日は［X2X0 D23M12］ではないか？」と、何回も宿主に問うた。宿主は意味が分からず、「今日は［X2X0 D24M12］だぞ。何がおかしい？」と言った。'
            },
            {
              id: 'g10',
              txt: 'その翌日、その騎士が宿泊していた部屋に置いてあった筈の古い鍵式の金庫がまるごと消えた。騎士が宿を出る再に特に盗んだような素振りも荷物もなかった為疑問に思ったが、単なる置物として置いてあっただけだった為、これを忘れる事にした。	'
            }

          ],
          mdCode: '4D617A65646F6C6C3037',
        },
      ]
    };
  },
  methods: {
    scrollToTarget (t){
 // 要素が含まれる集合オブジェクト (HTMLCollectionなど)
var elements = document.getElementsByClassName( "character_listItem" ) ;

// 番号を知りたい要素
var element = document.getElementById(t) ;

// HTMLCollectionから配列を作成
elements = [].slice.call( elements ) ;

// 要素の順番を取得
var index = elements.indexOf( element ) ;	// 2
/*
     function scrollToA(element, to, duration){
         
      var start = element.scrollY,
          change = to - start,
          currentTime = 0,
          increment = 20
              
      var animateScroll = function(){
          currentTime += increment
          var val = easeInOutQuad(currentTime, start, change, duration)


         element.scrollTo(0,val)
          if(currentTime < duration) {
              setTimeout(animateScroll, increment)
          }
    
      };
      var easeInOutQuad= function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      }
      animateScroll()
             
     }*/

    

        
        //     var target = document.getElementById(t);
      //var clientRect = target.getBoundingClientRect();
   // scrollToA(window, (index*100) + (--index*12) - 65 + 150,1000)},200);
   var val = (index*100) + (--index*16) - 65 + 150;
   if(window.innerWidth<1000){
   window.scrollTo(0,val)
   }


    
  }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.character {
  background: #000;

  color: #fff;
  padding: 72px 0 0;
  position: relative;

@include mq(lg){
  padding-top: 12px;
}
@include mq(){
  padding-top: 76px;
}

  &_in {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 36px;
    box-sizing: border-box;

    //   padding:0 12px;
    @include mq(lg) {
      padding: 12px 0 0;
    }
  }

  &_ttl {
    font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: 0.05em;

    //padding: 0 16px;
    &::after {
      content: "";
      width: 18px;
      height: 18px;
      display: inline-block;
      background: url(../assets/icon_suffix_2.svg) center center no-repeat;
      vertical-align: middle;
    }

    @include mq(lg) {
      padding-left: 12px;
    }
  }

  &_list {
    display: flex;
    justify-content: space-between;
    list-style: none;
    margin-top: 24px;
    padding-bottom: 64px;

    @include mq(lg) {
      display: block;
      padding: 0 0 16px;

    }
  }
&_listItemIn{
  @media screen and (min-width:1000px){
    width:100%;
    height:550px;
  }
  @include mq(lg){
width:100%;
height:100px;
  }
}
.is-selected .character_listItemIn{
  @include mq(lg){
  display: none;
  }
}
  &_listCont {
    position: absolute;
    bottom: 8px;
    left: 8px;

  }

  &_listNum {
    display: block;
  }

  &_listNumTxt {
    padding: 2px 4px;
    display: inline-block;
    font-size: 18px;
    font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;
    background-color: #000;
    margin-bottom: 4px;
    line-height: 1;

    &::before {
      content: "#";
      font-size: 14px;
    }
  }

  &_listName {
    display: block;
  }

  &_listNameTxt {
    text-transform: uppercase;
    font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;
    font-size: 24px;
    display: inline-block;
    background-color: #000;
    padding: 2px;
    line-height: 1;

    @media screen and (max-width:1280px) {
      font-size: 20px;
    }

  }

  &_detail {

    color: #000;

   
    justify-content: space-between;

  }

  &_detail-sp {
    background: #fff url(../assets/bg_dot_1.png);
    color: #000;

    justify-content: space-between;
    //opacity:0;
   height:0;
    transition: all 1s cubic-bezier(.06,.9,.2,.97);
    overflow: hidden;
    

  }
&_detail-pc{
              background: #fff url(../assets/bg_dot_1.png);

  .character_detailIn{
   //     max-width: 1600px;
   // margin: 0 auto;
  }
}
  &_detailIn {
    // padding: 42px 0;
    display: flex-item;

    
  }

  &_detailIn2 {
    @include mq(lg) {
      // padding: 0;
   padding: 60vh 16px 16px;
      margin-left: -12px;
    }
  }
  .is-selected &_detailIn2{
        @include mq(lg) {
  
     margin-left: 0;
    }
  }

@for $i from 1 through 7 {
  &_detailIn-#{$i} &_detailIn3 {
    background: url('../assets/chara_'+$i+'.png') top right no-repeat;
    background-size: 800px;
  }
    &_listItem-#{$i} &_detailIn2 {
  @include mq(lg) {
        background: url('../assets/chara_'+$i+'.png') no-repeat;

      background-position: top center;
      background-size: 65vmax;
    }


  }
}
&_listItem-4 &_detailIn2{
    @include mq(lg) {
      background-position:top center;
    }
    @include mq(){
      background-position:top left;
    }
}
&_listItem-5 &_detailIn2{
    @include mq(lg) {
      background-position:right top;
    }
    @include mq(){
      background-position:left top;
    }
    @media screen and (max-width:320px){
      .character_nameTxt{
        font-size:42px;
      }
    }
}
&_listItem-6 &_detailIn2{
    @include mq(lg) {
      background-position:left top;
    }

}





  &_detailTtl {
    padding-left: 20px;
    margin: 36px 0 16px;
    font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;
    position: relative;
    white-space: nowrap;

    @include mq(lg) {
      margin-left: -20px;
    }

    &::before {
      content: '';
      width: 16px;
      height: 1px;
      background-color: #000;
      position: absolute;
      top: 5px;
      left: 0;
    }
  }

  &_name {}

  &_num {
    display: block;
  }

  &_numTxt {
    background: #000;
    color: #fff;
    font-size: 40px;
    font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;
    display: inline-block;
    line-height: 1;
        padding: 0 8px;

    @include mq(lg) {
      font-size: 30px;
    }

    &::before {
      content: "#";
      font-size: 30px;

      @include mq(lg) {
        font-size: 20px;
      }
    }
  }

  &_name {
    display: inline-block;
    position: relative;
    text-transform: uppercase;
    margin-top: 4px;
  }

  &_nameTxt {
    font-size: 60px;
    background: #000;
    color: #fff;
    display: inline-block;
    line-height: 1;
    padding: 0 8px;
    font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;

    @include mq(lg) {
      font-size: 54px;
    }
  }

  &_nameJp {
    position: absolute;
    top: -14px;
    right: 4px;
    display: inline-block;
    font-size: 10px;
    @include mq(){
      background-color: #fff;
      padding:0 2px;
      top: -18px;
    }
  }

  &_latin {
    color: #ccc;
    display: block;
    font-size: 24px;
    font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;

    @include mq(lg) {
      font-size: 12px;
      color: #000;
      margin-top: 2px;
    }
  }

  &_reportId {
    font-size: 8px;
    color: #ccc;
    display: inline-block;
    margin-left: 1em;
    vertical-align: middle;

    &::before {
      content: "";
      width: 4px;
      height: 1.5em;
      border: solid 1px #ccc;
      border-right: 0;
      display: inline-block;
      margin-right: .25em;
      margin-top: -2px;

    }

    &::after {
      content: "";
      width: 4px;
      height: 1.5em;
      border: solid 1px #ccc;
      border-left: 0;
      display: inline-block;
      margin-left: .25em;
      margin-top: -2px;


    }
  }

  &_reportTxt {
    width: 40%;
    min-width:400px;
    margin-top: 12px;

    @include mq(lg) {
      width: 100%;
      min-width:0;
    }
  }

  &_reportTxtIn {
    font-size: 12px;
    text-align: justify;
    line-height: 1.6;
    background-color: #fff;

    &+& {
      margin-top: 1em;
    }
  }

  &_governingIn {
    display: flex;
    align-items: center;
  }

  &_countryInfo {
    font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;
    font-size: 21px;
    padding: 4px;
    white-space: nowrap;

    @include mq(lg) {
      //  padding-left:12px;
    }
  }

  &_countrySymbolImg {
    display: block;
    width: 60px;
    height: 60px;
    // background-color:#ccc;
  }

  &_countryCode {
    font-size: 12px;
    color: #ccc;
    display: block;
  }

  &_countryDesc {
    margin-top: 12px;
     width: 40%;
    min-width:400px;
   @include mq(lg) {
      width: 100%;
      min-width:0;
    }
  }

  &_countryDescTxt {
    font-size: 12px;
    text-align: justify;
    line-height: 1.6;
      background-color: #fff;

    &+& {
      margin-top: 1em;
    }
  }

  &_pcoDescTxt {
    font-size: 12px;
    text-align: justify;
    line-height: 1.6;
        width: 40%;
    min-width:400px;
      background-color: #fff;
   @include mq(lg) {
      width: 100%;
      min-width:0;
    }
    &+& {
      margin-top: 1em;
    }
  }
   &_pcoDescTxt2 {
    font-size: 12px;
    text-align: justify;
    line-height: 1.6;
   padding:12px 32px;
      background-color: #fff;
 
    &+& {
    //  margin-top: 1em;
    }
  }

  &_footer {
       margin-top: 32px;


  }

  &_footerMdNum {
    display: inline-block;
    background: #000;
    color: #fff;
    padding: 2px;
    vertical-align: middle;
    font-size: 10px;
    font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;
  }

  &_footerMdCode {
    font-size: 8px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 0.5em;
  }

  &_footerNameTxt {
    display: block;
    font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;
    font-size: 14px;
  }

  &_footerCode {
    font-size: 8px;
    display: block;
  }

  &_footerBarcode {
    height: 18px;

  }

  &_footer2 {
    margin-top: 4px;
  }
}






.character {
  &_detail-pc {
    height: 0;
    display: flex;
    flex-wrap: nowrap;
    transition: height 1s cubic-bezier(.06,.9,.2,.97);
    overflow: hidden;
    align-items: flex-start;
  }
}

.character.is-show {
  .character_detail-pc {
    height: auto;
  }

  .character_listItem {
    @media screen and (min-width:1000px) {
      height: 80px;

    }

   
  }
}

.character_detail-pc {
  @include mq(lg) {
    display: none !important;
  }
}
/*
@include mq(lg) {
  .character_listItem.is-selected {
   // height: auto !important;

    margin: 0 0 16px;

    .character_listCont {
      width: 0 !important;
      overflow: hidden;
      transition: all .5s ease;
    }

    .character_detail-sp {
      padding-top: 0;

      // padding:50vh 0 0;
      .character_detailIn {
        // padding:16px;
        padding: 0;
      }

      .character_detailIn2 {}
    }
  }
}
*/

.character_detail-sp {
  @media screen and (min-width:1000px) {
    display: none !important;

  }
}

.character_detailIn {
  transition: width .5s ease, padding .5s ease;
  overflow: hidden;
}

.character_detailIn2 {
  width: 100vw;
}
.character_detailIn3{
  margin: 0 auto;
  max-width: 1600px;
  min-height:1000px;
  box-sizing: border-box;
    padding: 60px 32px 60px;
}

.chara-enter {
  width: 0 !important;

}

.chara-enter-active {
  width: 100%;
}


.chara-leave {
  width: 100%;
}

.chara-leave-active {
  width: 0 !important;
}


.character_detailIn {

  width: 100%;



  @include mq(lg){
      padding:0;
    }
}
@keyframes pcoDesc1{
  0%{
  width: 40%;
    min-width:400px;
  }
  100%{
    width:100%;
  }
}
@keyframes pcoDesc2{
  0%{
    max-height:42px;
  }
  100%{
    max-height:400px;
  }
}
.character{
  &_pco{
     // transition: all .5s ease;
    @media screen and (min-width:1000px){
      width: 40%;
      //ax-width:40%;
   min-width:400px;
    margin-top: 36px;
      overflow:hidden;
     
      max-height: 42px;
      border: solid 1px #000;
      background-color: #fff;
      box-sizing: border-box;
     //         animation:pcoDesc2 .5s ease .5s reverse;
      transition:   max-height .5s cubic-bezier(.15,.7,.36,1) 0s,width 1s cubic-bezier(.15,.7,.36,1) .5s;

    &:hover{
      //order-width:2px;
     
     
      
    }

  
      &.is-active{
       height: auto;
        max-height:480px;
        width:100%;
      transition:    width .5s cubic-bezier(.15,.7,.36,1) 0s,max-height 1s cubic-bezier(.15,.7,.36,1) .5s;

        //animation:pcoDesc1 .5s forwards,pcoDesc2 .5s ease .5s forwards;
        .character_detailTtl2::after{
          transform:rotateZ(90deg);
        }
      }
    
 
    }
  }

  &_detailTtl2{
    display: block;
        font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;
padding:12px 16px 12px 32px;
cursor: pointer;
   position: relative;
    &::before{
      content:'';
  position: absolute;
  width: 11px;
  height: 1px;
  background-color: #000;
  left: 12px;
  top: 20px;

    }
      &::after{
      content:'';
  position: absolute;
  width: 1px;
  height: 11px;
  background-color: #000;
  left: 17px;
  top: 15px;
    transition:transform .5s ease;
    }

  &:hover{color: #00f;
     &::before,&::after{
        background-color: #00f;
      }
      }

  }
}
// list item
.character {


  &_listItem {
    cursor: pointer;
    overflow: hidden;
 transition: all .5s cubic-bezier(.15,.7,.36,1);
    @media screen and (min-width:1000px){
    background: #fff;
    height: 550px;
    margin-right: 16px;
    flex-grow: 0.5;
    position: relative;
   
    }
    @include mq(lg) {
      min-height:100px;
     // height: 100px;
      margin: 16px;
      //padding: 16px;
     max-height: 100px;
      //height:100px;
     // transition: all 1s cubic-bezier(.06,.9,.2,.97);
         position: relative;
      &.is-selected {
        padding: 0;
            //  height: auto;
      max-height: 2400px;
      margin: 0 !important;
    .character_listCont{
        left:-100%;
      
      }
      .character_detail-sp{
        height:auto;
        opacity:1;
      }
      }
    }

  }

  &_listItem:last-child {
    margin-right: 0;

    @include mq(lg) {
      margin-right: 16px;
    }
  }

  &_listItem:hover {
    flex-grow: 2;
  }

@for $i from 1 through 7 {
  &_listItem:nth-child(#{$i}) {
      background: #fff url('../assets/chara_line_' + $i + '.png') no-repeat;
    background-position: left 60% top 0;
    background-size: auto 1100px;

    @include mq(lg) {
    background-position: right 10% top 10%;
    background-size: auto 500px;
    }
  }
  
}

@media screen and (min-width:1000px){
&_listItem:nth-child(2){
  background-position:left 50% top 0;

}
&_listItem:nth-child(4){
  background-position:left 44% top 0% ;
}
&_listItem:nth-child(5){
  background-position:left 37% top 15%;
          background-size: auto 1300px;
}
&_listItem:nth-child(6){
  background-position:left 50% top 15%;
     background-size: auto 1300px;
}
}
@include mq(lg){
    &_listItem:nth-child(2){
    background-size: auto 550px;
}
  &_listItem:nth-child(3){
    background-size: auto 600px;
}
&_listItem:nth-child(4){

}
&_listItem:nth-child(5){

  
}
&_listItem:nth-child(6){

}
}
@include mq(){
  &_listItem:nth-child(1){
      background-position: right top 10%;
  }
  &_listItem:nth-child(2){
  background-position:right -60px top 10%;
    background-size: auto 550px;
}
&_listItem:nth-child(3){
  background-position: right -60px top 15%;
}
&_listItem:nth-child(4){
  background-position:right -120px top 10%;
}
&_listItem:nth-child(5){
  background-position:right -80px top 15%;
  
}
&_listItem:nth-child(6){
  background-position:right -70px top 15%;
}
&_listItem:nth-child(7){
  background-position:right -80px top 10%;
}
}


// 
    @media screen and (min-width:1000px){
  .is-show &_listItem:nth-child(1){

background-position: 60% 10%;
    background-size: auto 550px;
  }
    .is-show &_listItem:nth-child(2){

background-position: 50% 12%;
    background-size: auto 550px;
  }
    .is-show &_listItem:nth-child(3){

background-position: 60% 13%;
    background-size: auto 550px;
  }
    .is-show &_listItem:nth-child(4){

background-position: 40% 15%;
    background-size: auto 550px;
  }
    .is-show &_listItem:nth-child(5){

background-position: 37% 15%;
    background-size: auto 550px;
  }
    .is-show &_listItem:nth-child(6){

background-position: 40% 15%;
    background-size: auto 550px;
  }
  .is-show &_listItem:nth-child(7){

background-position: 60% 10%;
    background-size: auto 550px;
  }
  }

  @media screen and (min-width:1000px) {
    &_listItem:nth-child(1):hover {
      background: #74a2e6 url(../assets/chara_line_1_white.png) no-repeat;
    background-position: 60% 0;
      background-size: auto 1100px;
    }

    &_listItem:nth-child(2):hover {
      background: #a57bc8 url(../assets/chara_line_2_white.png) no-repeat;
          background-position: 50% 0;
            background-size: auto 1100px;

    }

    &_listItem:nth-child(3):hover {
      background: #93be6e url(../assets/chara_line_3_white.png) no-repeat;
          background-position: 60% 0;
            background-size: auto 1100px;

    }

    &_listItem:nth-child(4):hover {
      background: #e8692d url(../assets/chara_line_4_white.png) no-repeat;
          background-position: 42% 0;
            background-size: auto 1100px;

    }

    &_listItem:nth-child(5):hover {
      background: #8071da url(../assets/chara_line_5_white.png) no-repeat;
          background-position: 37% 15%;
            background-size: auto 1300px;

    }

    &_listItem:nth-child(6):hover {
      background: #e37dae url(../assets/chara_line_6_white.png) no-repeat;
          background-position: 50% 15%;
            background-size: auto 1300px;

    }

    &_listItem:nth-child(7):hover {
      background: #534b66 url(../assets/chara_line_7_white.png) no-repeat;
          background-position: 60% 0;
            background-size: auto 1100px;

    }
  }

  &.is-show{

  @media screen and (min-width:1000px) {
    .character_listItem:nth-child(1):hover {
      background: #74a2e6 url(../assets/chara_line_1_white.png) no-repeat;
    background-position: 60% 10% !important;
      background-size: auto 550px;
    }

    .character_listItem:nth-child(2):hover {
      background: #a57bc8 url(../assets/chara_line_2_white.png) no-repeat;
   background-position: 50% 12%;
    background-size: auto 550px;

    }

    .character_listItem:nth-child(3):hover {
      background: #93be6e url(../assets/chara_line_3_white.png) no-repeat;
background-position: 60% 13%;
    background-size: auto 550px;

    }

    .character_listItem:nth-child(4):hover {
      background: #e8692d url(../assets/chara_line_4_white.png) no-repeat;
background-position: 40% 15%;
    background-size: auto 550px;
  }

    .character_listItem:nth-child(5):hover {
      background: #8071da url(../assets/chara_line_5_white.png) no-repeat;
background-position: 37% 15%;
    background-size: auto 550px;
    }

    .character_listItem:nth-child(6):hover {
      background: #e37dae url(../assets/chara_line_6_white.png) no-repeat;
background-position: 40% 15%;
    background-size: auto 550px;

    }

    .character_listItem:nth-child(7):hover {
      background: #534b66 url(../assets/chara_line_7_white.png) no-repeat;
background-position: 60% 10%;
    background-size: auto 550px;
    }
  }
  }


}


</style>